export default "__VITE_ASSET__CqXy6hH5__"